module.exports = __webpack_public_path__ + "img/lqsx_5.4d7dd5c8.svg";